module.exports = __webpack_public_path__ + "img/chips500.6428cfcd.png";